import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/quicklinks.css";


function QuickLinks() {
  const navigate = useNavigate();

  const openHsCode = () => {
    window.open(
      `${process.env.PUBLIC_URL}/HS_CODES.pdf`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  const openDutyCalculator = () => {
    navigate("/approx-duty");
  };

  const openPopularVehicles = () => {
    navigate("/popular-vehicles");
  };

  const yenRate = "LKR 2.08"; // you can later fetch from API

  return (

    <div className="quick-links-container">

      <button className="quick-btn" onClick={openHsCode}>
        HS Codes
      </button>

      <button className="quick-btn" onClick={openDutyCalculator}>
        Approx. Duty
      </button>

      <div className="yen-wrapper">

        <button className="quick-btn yen-btn">
          Yen Rate
        </button>

        <div className="yen-popup">
          <h4>Today Yen Rate</h4>
          <p>1 JPY = {yenRate}</p>
        </div>

      </div>

      <button className="quick-btn" onClick={openPopularVehicles}>
        Popular Vehicle Models
      </button>

    </div>

  );

}

export default QuickLinks;